import { render, staticRenderFns } from "./HTMLView.vue?vue&type=template&id=2326e1a2&scoped=true&"
import script from "./HTMLView.vue?vue&type=script&lang=js&"
export * from "./HTMLView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2326e1a2",
  null
  
)

export default component.exports